"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _dailySettlementStatement = require("@/api/financialManagement/dailySettlementStatement");
var _BillingDetails = _interopRequireDefault(require("./components/BillingDetails.vue"));
var _memberBillingDetails = _interopRequireDefault(require("./components/memberBillingDetails.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DailySettlementStatement',
  components: {
    BillingDetails: _BillingDetails.default,
    memberBillingDetails: _memberBillingDetails.default
  },
  data: function data() {
    return {
      queryData: {
        scene: 0,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        page: 1,
        size: 10,
        billStartDay: null,
        // 账单日期开始范围
        billEndDay: null,
        // 账单日期结束范围

        billDay: null,
        memberId: null,
        phoneNo: null,
        settleStatus: null,
        // 结算状态：0-未结算，1-已结算
        settleType: null,
        // 结算类型：0-立即结算，1-定时结算
        settleAmountStart: null,
        // 结算总金额最小值
        settleAmountEnd: null,
        // 结算总金额最大值
        settleTimeStart: null,
        // 结算时间开始范围
        incrAmountStart: null,
        // 增长金额最小值
        incrAmountEnd: null // 增长金额最大值
      },
      dataList: [],
      total: 0,
      // 条数
      loading: false,
      // loading
      timeData: [],
      // 会员明细
      dialogVisible2: false,
      queryData1: {
        scene: 1,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        page: 1,
        size: 10,
        billDay: null,
        memberId: null,
        phoneNo: null,
        settleStatus: null,
        // 结算状态：0-未结算，1-已结算
        settleType: null,
        // 结算类型：0-立即结算，1-定时结算
        settleAmountStart: null,
        // 结算总金额最小值
        settleAmountEnd: null,
        // 结算总金额最大值
        settleTimeStart: null,
        // 结算时间开始范围
        incrAmountStart: null,
        // 增长金额最小值
        incrAmountEnd: null // 增长金额最大值
      },
      membershipDetailsData: [],
      membershipDetailsTotal: 0
    };
  },
  created: function created() {
    this.listBillStatsPaged();
  },
  methods: {
    listBillStatsPaged: function () {
      var _listBillStatsPaged2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              if (this.timeData.length > 0) {
                params.billStartDay = this.timeData[0];
                params.billEndDay = this.timeData[1];
              }
              _context.n = 1;
              return (0, _dailySettlementStatement.listBillStatsPaged)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.total = res.data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function listBillStatsPaged() {
        return _listBillStatsPaged2.apply(this, arguments);
      }
      return listBillStatsPaged;
    }(),
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listBillStatsPaged();
    },
    onInit: function onInit() {
      this.init();
      this.listBillStatsPaged();
    },
    init: function init() {
      this.queryData = {
        scene: 0,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        page: 1,
        size: 10,
        billDay: null,
        memberId: null,
        phoneNo: null,
        billStartDay: null,
        // 账单日期开始范围
        billEndDay: null,
        // 账单日期结束范围
        settleStatus: null,
        // 结算状态：0-未结算，1-已结算
        settleType: null,
        // 结算类型：0-立即结算，1-定时结算
        settleAmountStart: null,
        // 结算总金额最小值
        settleAmountEnd: null,
        // 结算总金额最大值
        settleTimeStart: null,
        // 结算时间开始范围
        incrAmountStart: null,
        // 增长金额最小值
        incrAmountEnd: null // 增长金额最大值
      };
      this.timeData = [];
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listBillStatsPaged();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listBillStatsPaged();
    },
    // 账单详情------------------------
    onBillingDetails: function onBillingDetails(val) {
      this.$refs.billingDetails.open(val);
    },
    onBillingDetails1: function onBillingDetails1(val) {
      this.$refs.memberBillingDetails.open(val);
    },
    // 会员明细-----------------------------------
    listBillStatsPaged1: function () {
      var _listBillStatsPaged3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData1);
              _context2.n = 1;
              return (0, _dailySettlementStatement.listBillStatsPaged)(params);
            case 1:
              res = _context2.v;
              this.loading = false;
              if (res.code === 0) {
                this.membershipDetailsData = res.data.data;
                this.membershipDetailsTotal = res.data.total;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function listBillStatsPaged1() {
        return _listBillStatsPaged3.apply(this, arguments);
      }
      return listBillStatsPaged1;
    }(),
    onMemberAccountDetail: function onMemberAccountDetail(value) {
      this.queryData1.page = 1;
      this.queryData1.size = 10;
      this.queryData1.billDay = value.billDay;
      this.dialogVisible2 = true;
      this.listBillStatsPaged1();
    },
    onInquire1: function onInquire1() {
      this.queryData1.page = 1;
      this.queryData1.size = 10;
      this.listBillStatsPaged1();
    },
    onInitialize: function onInitialize() {
      this.queryData1 = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.queryData1), {
        phoneNo: null,
        scene: 1,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        memberId: null,
        settleStatus: '',
        // 结算状态：0-未结算，1-已结算
        settleAmountStart: '',
        settleAmountEnd: '',
        incrAmountStart: '',
        incrAmountEnd: '',
        page: 1,
        size: 10
      });
      this.listBillStatsPaged1();
    },
    handleSizeChange1: function handleSizeChange1(val) {
      this.queryData1.size = val;
      this.listBillStatsPaged1();
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.queryData1.page = val;
      this.listBillStatsPaged1();
    },
    handleClose1: function handleClose1(done) {
      done();
    },
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.memberName
        }
      });
    }
  }
};